module.exports = __webpack_public_path__ + "img/art-kids.446f05cf.png";